<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-cont-box">
            <div class="line-cont">
              <div class="v-line-desc text-overflow">
                {{ item.dec }}<span  class="tag">{{ item.tag }}</span>
              </div>
              <div class="v-line-tag text-overflow">
                {{ item.desc }}
              </div>
            </div>
            <div v-maidian="type + '_' + index" class="line-btm clear">
              <div class="price">
                <span class="price-span"
                  >{{ discount ? item.price * 0.8 : item.price }}<i>起</i></span
                >
                <mt-button @click="jumpToSight(item.linkId)" size="small">查看</mt-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['lineList', 'tag', 'type'],
  data() {
    return {
      discount: false,
    };
  },
  methods: {
    jumpToSight(url) {
      location.href = url;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  &-head {
    img {
      width: 100%;
      height: 112px;
    }
  }
  &-box {
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 10px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 9px;
    float: left;
    z-index: 2;
    display: flex;
    height: 130px;
    align-items: center;
    .line-head{
      img{
        width:178px;
        height: 130px;
      }
    }
    .v-line-desc{
      font-weight: bold;
      font-size: 15px;
      .tag{
        font-weight: normal;
        margin-left: 5px;
      }
    }
    .line-cont-box{
      height: 90px;
    }
    &-box {
      position: relative;
      .bg-line {
        background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
          no-repeat;
        background-size: 100% auto;
        height: 20px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 7px;
      }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    padding-bottom: 0;
    text-align: left;
    width:158px;
  }
  &-btm {
    padding: 7px;
    .price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 15px;
        float: left;
        color: #ff414d;
        i {
          font-style: normal;
          font-size: 9px;
          margin-left: 2px;
        }
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: '￥';
          font-size: 9px;
          position: relative;
        }
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    img {
      display: block;
    }
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background: linear-gradient(-54deg, #ffaf61 0%, #f719a1 100%);
    border-radius: 11px;
    color: #fff;
    font-size: 11px;
    height: 22px;
  }
  .v-line-tag {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
    margin-bottom: 8px;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
</style>